import React, { useEffect } from 'react';

import { ReactComponent as ShoppingCartIcon } from '@pkg/assets/icons/v2/shopping-cart.svg';
import { useAppDispatch, useAppSelector } from '@pkg/hooks';

import { apiFactory, Cart } from '@app/client';
import { setOrderItems } from '@app/store/actions/picker';
import { useAuthTokens } from '@app/store/zustand/auth/useAuthTokens';

import { NoticePip, StyledCartButton } from './CartButton.style';

interface Props {
    forceInline?: boolean;
}

export function CartButton({ forceInline }: Props) {
    const dispatch = useAppDispatch();
    const { orderItems } = useAppSelector(({ picker }) => picker);
    const { isAuthenticated } = useAuthTokens();

    useEffect(() => {
        if (!isAuthenticated) return;

        apiFactory()
            .call(Cart.getCart, {})
            .then((r) => {
                if (r.ok) {
                    dispatch(setOrderItems(r.value.order_items));
                }
            });
    }, [isAuthenticated, dispatch]);

    if (orderItems.length === 0) return null;

    return (
        <StyledCartButton to="/checkout" state={{ state: { enableGoBack: true } }} $forceInline={forceInline}>
            <ShoppingCartIcon />
            <NoticePip>{orderItems.length}</NoticePip>
        </StyledCartButton>
    );
}
